import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { removeWhitelistedUrl } from '../superAdminActions';

import InfoTooltip from 'utils/components/info-tooltip';

class BlacklistedItemComponent extends Component {
  static displayName = 'BlacklistedItem';

  static propTypes = {
    url: PropTypes.string.isRequired,
    spotId: PropTypes.string.isRequired
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  onUrlRemove() {
    var { spotId, url } = this.props;
    this.props.removeUrl(url);
  }

  showTooltipInfo() {
    if (this.props.url.length > 45) {
      this.refs.infoTooltip.show();
    }
  }

  hideTooltipInfo() {
    this.refs.infoTooltip.hide();
  }

  render() {
    var { url } = this.props;
    // let className = classnames('url', {
    //     'link': validators.url(url)
    // });

    return (
      <div className="url-item">
        <div className="url-wrapper" ref="infoTooltipAlign">
          {
            /*validators.url(url)*/ false ? (
              <a
                href={url}
                className="url link"
                onMouseLeave={this.hideTooltipInfo.bind(this)}
                onMouseEnter={this.showTooltipInfo.bind(this)}
              >
                {url}
                <InfoTooltip
                  ref="infoTooltip"
                  alignElement={() => this.refs.infoTooltipAlign}
                  direction="top"
                >
                  <span className="text">{url}</span>
                </InfoTooltip>
              </a>
            ) : (
              <div className="url">{url}</div>
            )
          }
        </div>
        <span className="remove-url" onClick={this.onUrlRemove.bind(this)}>
          Remove
        </span>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  removeUrl: props => {
    dispatch(removeWhitelistedUrl(props));
  }
});

export const BlacklistedItem = connect(undefined, mapDispatchToProps)(BlacklistedItemComponent);
